import { Link } from "react-router-dom";
import "./AonLink.component.scss";
import { LINK_STYLE, LINK_TYPE } from "./consts";
import { LABEL_TYPE, AonLabel, LABEL_STYLE } from "../AonLabel";
import React from "react";
var AonLink = function (_a) {
    var type = _a.type, style = _a.style, children = _a.children, _b = _a.inline, inline = _b === void 0 ? true : _b, to = _a.to, darkMode = _a.darkMode;
    var labelType;
    var labelStyle;
    switch (type) {
        case LINK_TYPE.H3:
            labelType = LABEL_TYPE.H3;
            break;
        case LINK_TYPE.H4:
            labelType = LABEL_TYPE.H4;
            break;
        case LINK_TYPE.H5:
            labelType = LABEL_TYPE.H5;
            break;
        case LINK_TYPE.H6:
            labelType = LABEL_TYPE.H6;
            break;
        case LINK_TYPE.BODY:
            labelType = LABEL_TYPE.BODY;
            break;
        case LINK_TYPE.SMALL:
            labelType = LABEL_TYPE.SMALL;
            break;
        case LINK_TYPE.EXTRA_SMALL:
            labelType = LABEL_TYPE.EXTRA_SMALL;
            break;
        case LINK_TYPE.LARGE:
            labelType = LABEL_TYPE.LARGE;
            break;
        case LINK_TYPE.EXTRA_LARGE:
            labelType = LABEL_TYPE.EXTRA_LARGE;
            break;
        default:
            labelType = LABEL_TYPE.BODY;
            break;
    }
    switch (style) {
        case LINK_STYLE.BOLD:
            labelStyle = LABEL_STYLE.BOLD_LINK;
            break;
        case LINK_STYLE.ITALIC:
            labelStyle = LABEL_STYLE.ITALIC_LINK;
            break;
        case LINK_STYLE.LIGHT:
            labelStyle = LABEL_STYLE.LIGHT_LINK;
            break;
        case LINK_STYLE.REGULAR:
            labelStyle = LABEL_STYLE.LINK;
            break;
        default:
            labelStyle = LABEL_STYLE.LINK;
            break;
    }
    return (React.createElement(Link, { to: to },
        React.createElement(AonLabel, { type: labelType, style: labelStyle, inline: inline || false, darkMode: darkMode }, children)));
};
export { AonLink };
